import React, { useEffect, useState } from 'react';
import { Sun, Moon } from 'lucide-react';

// User-facing light/dark theme switch. Toggles the `dark` class on <html>
// (Tailwind darkMode: 'class') and persists the choice in localStorage.
const getInitial = () => {
  try {
    const saved = localStorage.getItem('rvx_theme');
    if (saved) return saved;
  } catch (e) { /* ignore */ }
  return typeof window !== 'undefined' && window.matchMedia?.('(prefers-color-scheme: dark)').matches
    ? 'dark' : 'light';
};

const apply = (theme) => {
  const root = document.documentElement;
  if (theme === 'dark') root.classList.add('dark');
  else root.classList.remove('dark');
};

export const ThemeToggle = () => {
  const [theme, setTheme] = useState(getInitial);

  useEffect(() => {
    apply(theme);
    try { localStorage.setItem('rvx_theme', theme); } catch (e) { /* ignore */ }
  }, [theme]);

  const isDark = theme === 'dark';
  return (
    <button
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
      className="p-2 rounded-lg text-slate-500 hover:text-slate-900 hover:bg-slate-100 dark:text-slate-300 dark:hover:text-white dark:hover:bg-slate-800 transition-colors focus:outline-none focus:ring-2 focus:ring-primary/30"
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-pressed={isDark}
      title={isDark ? 'Light mode' : 'Dark mode'}
      data-testid="theme-toggle"
    >
      {isDark ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
    </button>
  );
};

export default ThemeToggle;
